// 对于数据的存取  对cookie的操作

import Cookies from 'js-cookie'

const SessionidKey = 'Session-Id';
const MenuKey = 'Admin-Menu';
const userNameKey = 'User-Name';
const isJsonDataKey = "is-JsonData";
const isUserIdKey = 'user-Id';
const isOrgUser = 'Org-User';


export function getCookie(key) {
    return Cookies.get(key)
}

export function setCookie(key, value) {
    return Cookies.set(key, value)
}

export function removeCookie(key) {
    return Cookies.remove(key)
}

export function removeSave(key) {
    removeCookie("roles-User");
    removeCookie('Session-Id');
    removeCookie('User-Name');
    removeCookie('user-Id');
    removeCookie("is-JsonData")
    removeCookie("is-WorkData")
    removeCookie("second-orgId");
    removeCookie("Org-User");
    // localStorage.removeItem("Session-Id")
    localStorage.removeItem("siteBtn");
    localStorage.removeItem("siteMenuAD");
    removeCookie("organ-Ids");
    removeCookie('currOrgIds');
}

export function setLogin(data) {
    setCookie("user-Id", data.userid);
    setCookie("Session-Id", data.sessionid);
    setCookie("User-Name", data.username);
    setCookie("Org-User", data.accflag);
    setCookie("roles-User", JSON.stringify(data.roles));
    if (data.organids.length > 0) {
        setCookie(
            "organ-Ids",
            JSON.stringify(data.organids[0].orgname)
        );
    }
    setCookie("second-orgId", JSON.stringify(data.secondOrgId));
    setCookie("currOrgIds", JSON.stringify(data.currorganid));
}


// WEBPACK FOOTER //
// ./src/utils/auth.js